import { Paper, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ProductCard = ({ title, imageSrc, imageAlt, imageCount, linkTo, isRtl = false }) => {
  const { t } = useTranslation();

  return (
    <Paper
      component={Link}
      to={linkTo}
      className="overflow-hidden transition-all duration-300 hover:shadow-xl cursor-pointer h-full block !rounded-lg"
      elevation={2}
    >
      <div className="relative h-64 overflow-hidden">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <Typography variant="h5" component="h3" className="mb-2" style={{ fontWeight: 700 }}>
            {title}
          </Typography>
          <Typography variant="body2" className="opacity-90">
            {t('products.imagesCount', { count: imageCount })}
          </Typography>
        </div>
      </div>
    </Paper>
  );
};

export default ProductCard;
